export const API_BASE_URL = 'https://api-backend.hppartnerassessment.com';
export const TYPEFORM_URL = 'https://5rzmnwhywta.typeform.com/to/';

